import type { CustomDomainsTranslations } from '../interfaces/customDomains';

export const customDomainsTranslations: CustomDomainsTranslations = {
  eyebrow: 'Organização',
  title: 'Domínios próprios',
  sub: 'Sirva o painel, a API e os e-mails a partir dos domínios da sua empresa. Seu DNS fica onde está: você só publica os registros que mostramos.',
  disabled_title: 'Indisponível neste ambiente',
  disabled_text: 'Os domínios próprios ainda não estão habilitados aqui.',
  load_error: 'Não conseguimos carregar seus domínios. Tente novamente.',

  kind_frontend_title: 'Painel',
  kind_frontend_desc: 'Sua equipe acessa o {{brand}} em, por exemplo, app.suaempresa.com.',
  kind_backend_title: 'API',
  kind_backend_desc: 'A API, os webhooks e o painel no seu domínio usam, por exemplo, api.suaempresa.com.',
  kind_email_title: 'E-mail',
  kind_email_desc: 'Convites, recuperação de senha e avisos são enviados a partir do seu domínio.',

  add: 'Configurar',
  verify_now: 'Verificar agora',
  retry: 'Tentar novamente',
  delete: 'Remover',
  cancel: 'Cancelar',
  copy: 'Copiar',
  copied: 'Copiado',
  history: 'Ver histórico',
  hide_history: 'Ocultar histórico',

  status_pending_dns: 'Aguardando DNS',
  status_provisioning: 'Configurando',
  status_active: 'Ativo',
  status_degraded: 'Com problemas',
  status_deleting: 'Removendo',
  status_deleted: 'Removido',
  status_failed: 'Erro',

  records_title: 'Registros DNS',
  records_intro: 'Crie estes registros no provedor DNS do seu domínio. Verificamos a cada poucos minutos; você também pode pedir uma verificação.',
  col_type: 'Tipo',
  col_name: 'Nome',
  col_value: 'Valor',
  col_state: 'Status',
  record_seen: 'Detectado',
  record_missing: 'Pendente',
  purpose_routing: 'Aponta seu domínio para o {{brand}}',
  purpose_ownership: 'Confirma que o domínio é seu',
  purpose_certificate_validation: 'Emissão do certificado HTTPS',
  purpose_dkim: 'Assinatura DKIM',
  purpose_mail_from_mx: 'MAIL FROM (devoluções)',
  purpose_mail_from_spf: 'SPF do MAIL FROM',
  purpose_dmarc: 'Política DMARC',

  note_dns_only: 'Se o seu DNS está na Cloudflare, crie os CNAME no modo "Somente DNS" (nuvem cinza).',
  note_acm_keep: 'Não apague o registro do certificado: ele é usado para renová-lo automaticamente.',
  note_caa: 'Se o seu domínio tem registros CAA, autorize amazon.com, letsencrypt.org, pki.goog e ssl.com.',
  note_dmarc: 'Se o seu domínio já tem um DMARC, não precisa de outro; o sugerido é um ponto de partida.',
  note_relogin: 'Sua equipe precisará entrar novamente ao usar o novo domínio.',
  note_email_fallback: 'Até ficar ativo, os e-mails continuam saindo pelo {{brand}}.',

  last_checked: 'Última verificação',
  last_error: 'Detalhe',
  mail_from: 'Remetente',
  dmarc_policy: 'Política DMARC',
  never: 'Ainda não',

  dialog_title: 'Configurar domínio',
  dialog_desc_frontend: 'Use um subdomínio (não o domínio raiz), por exemplo app.suaempresa.com.',
  dialog_desc_backend: 'Use um subdomínio (não o domínio raiz), por exemplo api.suaempresa.com.',
  dialog_desc_email: 'Pode ser o seu domínio raiz ou um subdomínio dedicado ao e-mail.',
  hostname_label: 'Domínio',
  hostname_placeholder_frontend: 'app.suaempresa.com',
  hostname_placeholder_backend: 'api.suaempresa.com',
  hostname_placeholder_email: 'suaempresa.com',
  hostname_required: 'Digite um domínio.',
  from_local_part_label: 'Endereço',
  from_local_part_invalid: 'Use apenas letras, números, pontos, hífens ou sublinhado.',
  from_name_label: 'Nome do remetente',
  from_name_help: 'O que seus clientes veem junto ao endereço. Por padrão, {{brand}}.',
  from_name_invalid: 'Não pode ter aspas nem os sinais < >.',
  mail_from_subdomain_label: 'Subdomínio do MAIL FROM',
  mail_from_subdomain_help: 'Recebe as devoluções e alinha o SPF. Mude apenas se "mail" já estiver em uso.',
  mail_from_subdomain_invalid: 'Use apenas letras minúsculas, números e hífens.',
  submit: 'Salvar e ver registros',

  delete_title: 'Remover este domínio?',
  delete_text: 'Ele deixa de funcionar imediatamente e removemos o certificado e a configuração. Você pode adicioná-lo de novo depois.',
  delete_confirm: 'Remover domínio',

  toast_created: 'Domínio salvo. Publique os registros DNS para ativá-lo.',
  toast_deleted: 'Domínio removido.',
  toast_verify: 'Verificação em andamento.',
  toast_retry: 'Tentando configurar novamente.',

  error_INVALID_HOSTNAME: 'Esse domínio não é válido.',
  error_APEX_NOT_ALLOWED: 'Use um subdomínio, não o domínio raiz.',
  error_RESERVED_DOMAIN: 'Esse domínio não pode ser usado.',
  error_HOSTNAME_TAKEN: 'Outra organização já usa esse domínio.',
  error_CUSTOM_DOMAIN_KIND_EXISTS: 'Você já tem um domínio deste tipo. Remova-o primeiro para trocá-lo.',
  error_CUSTOM_DOMAINS_DISABLED: 'Os domínios próprios não estão habilitados neste ambiente.',
  error_CUSTOM_FRONTEND_UNAVAILABLE: 'O painel em domínio próprio não está disponível para esta plataforma.',
  error_generic: 'Não conseguimos concluir a ação. Tente novamente.',
};
